import Vue from 'vue';
export default Vue.extend({
    name: 'v-list-item-icon',
    functional: true,
    render(h, { data, children }) {
        data.staticClass = `v-list-item__icon ${data.staticClass || ''}`.trim();
        return h('div', data, children);
    }
});
